<template>
    <div class="admin-frame">
        <NavBar/>
        <modale :show="showModale" @toggle="toggleModale">
            <AdminForm @valueSaved="formSaved"/>
        </modale>

        <div class="admin-page">
            <div class="add-btn" @click="toggleModale">
                <span class="material-symbols-outlined">person_add</span>
            </div>
            <h2>Administrateurs ({{ activeAdminList.length }})</h2>

            <table>
                <tr>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Super admin</th>
                    <th>Actif</th>
                    <th>Modifier</th>
                </tr>

                <tr v-for="admin in activeAdminList" :key="admin._id">
                    <td>{{ admin.firstname }}</td>
                    <td>{{ admin.lastname }}</td>
                    <td>
                        <input type="checkbox" v-model="admin.is_super_admin" disabled>
                    </td>
                    <td><input type="checkbox" v-model="admin.is_active" disabled></td>
                    <td @click="current_edit = admin._id">
                        <span class="material-symbols-outlined" style="cursor: pointer">border_color</span>
                        <modale :show="current_edit == admin._id" @toggle="current_edit = undefined">
                            <AdminForm :adminData="admin" @valueSaved="formSaved" />
                        </modale>
                    </td>
                </tr>
            </table>


            <h2>Administrateurs inactifs ({{ inactiveAdminList.length }})</h2>

            <table>
                <tr>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Super admin</th>
                    <th>Actif</th>
                    <th>Modifier</th>
                </tr>

                <tr v-for="admin in inactiveAdminList" :key="admin._id">
                    <td>{{ admin.firstname }}</td>
                    <td>{{ admin.lastname }}</td>
                    <td>
                        <input type="checkbox" v-model="admin.is_super_admin" disabled>
                    </td>
                    <td><input type="checkbox" v-model="admin.is_active" disabled></td>
                    <td @click="current_edit = admin._id">
                        <span class="material-symbols-outlined" style="cursor: pointer">border_color</span>
                        <modale :show="current_edit == admin._id" @toggle="current_edit = undefined">
                            <AdminForm :adminData="admin" @valueSaved="formSaved" />
                        </modale>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import AdminForm from './AdminForm.vue';

export default {
    components: {
        AdminForm,
    },
    data() {
        return {
            showModale: false,
            adminList: [],
            current_edit: undefined,
        }
    },
    methods: {
        toggleModale() {
            this.showModale = !this.showModale;
        },
        async getAllAdmin() {
            const res = await axios.get(this.$store.getters.get_api_url + 'auth/all/');
            this.adminList = res.data;
        },
        formSaved() {
            this.showModale = false;
            this.current_edit = undefined;
        }
    },
    computed: {
        activeAdminList() {
            return this.adminList.filter(a => a.is_active);
        },
        inactiveAdminList() {
            return this.adminList.filter(a => !a.is_active);
        },
    },
    beforeMount() {
        this.getAllAdmin();
    }
}
</script>

<style scoped>
.admin-frame {
    position: relative;
}

.admin-page {
    position: absolute;
    top: 15%;
    right: 10%;
    left: 10%;
    margin: 100px auto;
    background-color: white;
    box-shadow: 0px 0px 10px -3px #C7C7C7;
    border-radius: 20px;
}

.admin-page h2 {
    padding: 10px 5%;
    color: #296A9D;
    font-size: 32px;
}

.add-btn {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 15px;
    background-color: #F4706A;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    border-radius: 50px;
    color: white;
    font-weight: bold;
}

.add-btn:hover {
    background-color: #E48094;
}

table {
    margin: 20px auto;
    width: 90%;
    border-collapse: collapse;
}

td,
th {
    border: 1px lightgray solid;
    padding: 2px;
    text-align: center;
    font-size: 12px;
    color: rgb(82, 82, 82);
}

th {
    background-color: #296A9D;
    color: white;
    padding: 10px;
}

td .material-symbols-outlined:hover {
    color: #F4706A;
}
</style>